'use client';

import { createContext, ReactNode, useContext } from 'react';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export interface AppConfig {
	deviceType: DeviceType;
	isImpersonationInProcess: boolean;
	hideBackToTop: boolean;
	isWebview: boolean;
}

interface AppConfigContextProps {
	config: AppConfig;
}

const AppConfigContext = createContext<AppConfigContextProps | undefined>(undefined);

interface AppConfigProviderProps {
	children: ReactNode;
	config: AppConfig;
}

export const AppConfigProvider = ({ children, config }: AppConfigProviderProps) => {
	return <AppConfigContext.Provider value={{ config }}>{children}</AppConfigContext.Provider>;
};

export const useAppConfig = () => {
	const context = useContext(AppConfigContext);
	if (!context) {
		throw new Error('useAppConfig must be used within an AppConfigProvider');
	}
	return context;
};
